export const CLEAR_CUSTOMER_SEARCH = 'CLEAR_CUSTOMER_SEARCH';
export const SET_CUSTOMERS = 'SET_CUSTOMERS';
export const SET_SELECTED_CUSTOMER = 'SET_SELECTED_CUSTOMER';
